import { render, staticRenderFns } from "./CulturaDashboard.vue?vue&type=template&id=4d799446&scoped=true"
import script from "./CulturaDashboard.vue?vue&type=script&lang=js"
export * from "./CulturaDashboard.vue?vue&type=script&lang=js"
import style0 from "./CulturaDashboard.vue?vue&type=style&index=0&id=4d799446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d799446",
  null
  
)

export default component.exports